export const currentDateString = () => {
  const now = Date(Date.now()).toLocaleString();
  const today = now.split(',')[0];
  return today;
};

export const findWithProp = (array, prop, value) => {
  for (let i = 0; i < array.length; i += 1) {
    if (array[i][prop] === value) {
      return i;
    }
  }
  return -1;
};



// WEBPACK FOOTER //
// ./src/utils/index.js